import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { assign } from 'xstate';
import { cloneDeep } from 'lodash';
import { IntlShape } from 'react-intl';

import { SendContext } from '../../SendContext';
import { MachineContext } from '../../MachineContext';
import { BaseComponent } from '../Component';
import { translateWithFallback } from '../../util';
import {EvoachButton} from "../Button";

export interface YesNoButtonComponent extends BaseComponent {
  type: 'yesNoButton';
  props: YesNoButtonProps;
}
export interface YesNoButtonProps {
  yesButtonText: string;
  noButtonText: string;
  saveResultTo: string;
}
export const YesNoButton: React.FC<YesNoButtonProps> = ({
  yesButtonText,
  noButtonText,
  saveResultTo,
}) => {
  const { send } = useContext(SendContext);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '1em',
      }}
    >
      <EvoachButton
        onClick={() => {
          send({
            type: 'writeToContext',
            payload: { [saveResultTo]: yesButtonText },
          });
          send({
            type: 'yes',
          });
        }}
      >
        {yesButtonText}
      </EvoachButton>
      <EvoachButton
        onClick={() => {
          send({
            type: 'writeToContext',
            payload: { [saveResultTo]: noButtonText },
          });
          send({
            type: 'no',
          });
        }}
      >
        {noButtonText}
      </EvoachButton>
    </Box>
  );
};

export const renderYesNoButtonAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    newContext.widgetData.push({
      type: 'yesNoButton',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        yesButtonText: translateWithFallback(
          intl,
          actionMetadata.action.payload.buttonTextYes
        ),
        noButtonText: translateWithFallback(
          intl,
          actionMetadata.action.payload.buttonTextNo
        ),
        saveResultTo: actionMetadata.action.payload.saveResultTo,
      },
    });
    return newContext;
  });
};
